import moment from 'moment';
import { parseDateString } from '../functions/utils';
import { FeatureRooms } from './chatRoom';

interface IApiFreeChatBanner {
  BannerImageUrl?: string;
  AnnouncementType?: boolean;
}

interface IApiDailyFreeOpeningHoursData {
  OpeningTime: string;
  ClosingTime: string;
}

interface IApiDailyFreeOpeningHoursResponse {
  DailyFreeOpeningHours: IApiDailyFreeOpeningHoursData;
  DisplayFreeChat?: boolean;
  FreeChatBanner?: {
    Mobile?: IApiFreeChatBanner;
    Desktop?: IApiFreeChatBanner;
  };
  FeatureRooms?: any[];
}

export class FreeChatBanner {
  bannerImageUrl: string;
  announcementType: boolean;

  constructor(bannerObject: IApiFreeChatBanner) {
    this.bannerImageUrl = bannerObject.BannerImageUrl || '';
    this.announcementType = bannerObject.AnnouncementType || false;
  }
}

export interface IFreeChatBannerMap {
  mobile?: FreeChatBanner;
  desktop?: FreeChatBanner;
}

export default class DailyFreeOpeningHours {
  openingTime: moment.Moment | null;
  closingTime: moment.Moment | null;
  openingTimeString: string;
  closingTimeString: string;
  displayFreeChat: boolean;
  freeChatBanner: IFreeChatBannerMap | undefined;
  featureRooms: FeatureRooms[];
  closingTimeInDate: Date | null;

  constructor() {
    this.openingTime = null;
    this.closingTime = null;
    this.openingTimeString = '';
    this.closingTimeString = '';
    this.displayFreeChat = false;
    this.freeChatBanner = undefined;
    this.featureRooms = [];
    this.closingTimeInDate = null;
  }

  static mappingObject(_obj: IApiDailyFreeOpeningHoursResponse): DailyFreeOpeningHours {
    const obj = new DailyFreeOpeningHours();
    const openingTime = _obj.DailyFreeOpeningHours ? moment.utc(_obj.DailyFreeOpeningHours.OpeningTime) : null;
    const closingTime = _obj.DailyFreeOpeningHours ? moment.utc(_obj.DailyFreeOpeningHours.ClosingTime) : null;

    // AEDT time is +11
    // obj.openingTimeString = openingTime ? openingTime.utcOffset("+11:00").format('h:mm A') : "";
    // obj.closingTimeString = closingTime ? closingTime.utcOffset("+11:00").format('h:mm A') : "";
    obj.openingTimeString = openingTime ? openingTime.local().format('h:mm A') : '';
    obj.closingTimeString = closingTime ? closingTime.local().format('h:mm A') : '';

    // obj.openingTime = _obj.OpeningTime ? moment(_obj.OpeningTime, ["h:mm A"]) : null;
    obj.openingTime = openingTime ? openingTime.local() : null;
    // obj.closingTime = _obj.ClosingTime ? moment(_obj.ClosingTime, ["h:mm A"]) : null;
    obj.closingTime = closingTime ? closingTime.local() : null;
    obj.closingTimeInDate = closingTime ? closingTime.toDate() : null;
    obj.displayFreeChat = !!_obj.DisplayFreeChat;

    if (_obj.FreeChatBanner) {
      obj.freeChatBanner = {};
      if (_obj.FreeChatBanner.Mobile) {
        obj.freeChatBanner.mobile = new FreeChatBanner(_obj.FreeChatBanner.Mobile);
      }
      if (_obj.FreeChatBanner.Desktop) {
        obj.freeChatBanner.desktop = new FreeChatBanner(_obj.FreeChatBanner.Desktop);
      }
    }

    if (_obj.FeatureRooms) {
      obj.featureRooms = _obj.FeatureRooms.map(room => new FeatureRooms(room));
    }
    return obj;
  }

  static mappingBanner(_obj: any) {
    // Original function was empty/incomplete:
    // let obj;
    // Leaving returning void/undefined as per original
    let obj;
    return obj;
  }

  static mappingObjects(_objs: IApiDailyFreeOpeningHoursResponse[]): DailyFreeOpeningHours[] {
    return _objs.map(obj => DailyFreeOpeningHours.mappingObject(obj));
  }
}
